

























import {Vue, Component, Prop, Inject} from 'vue-property-decorator';

import {isEmptyOrWhiteSpace} from "@/utils/Common";
import {API_BIS_FILTER} from "@/configs/Apis";
import {showSuccess} from "@/utils/UI";
import AdvSearch from "@/views/base/AdvSearch.vue";

@Component({
    components: {AdvSearch}
})
export default class AdvSearchDialog extends Vue {
    @Prop({type: Boolean, default: () => false})
    visible!: boolean;

    @Prop({type: String, default: () => ""})
    condition!: string;

    @Prop({type: String, default: () => ""})
    categoryData!: string;

    @Inject()
    projectId!: string;

    filterData: any = {name: "", markPublic: false};

    showSaveFilterWin: boolean = false;

    appendFields: Array<any> = [];

    savedFilter: boolean = false;

    created() {
        const customfields = this.$store.getters['project/customfields'];
        if (customfields && customfields.length) {
            this.appendFields.push(...customfields.map((field: any) => {
                const item: any = {name: field.fieldName, label: field.label, group: "标引字段"};
                if (field.fieldType === "ENUM") {
                    item.type = "enum";
                    item.enumValues = [];
                    if (!isEmptyOrWhiteSpace(field.enumValues)) {
                        item.enumValues.push(...field.enumValues.split(/[\r\n;]/g));
                    }
                } else {
                    item.type = "text";
                }
                return item;
            }));
        }
        if (!isEmptyOrWhiteSpace(this.categoryData)) {
            const treeData: Array<any> = JSON.parse(this.categoryData);
            this.appendFields.push(...treeData.map((field: any) => ({name: `category${field.id}`, label: field.name, type: "tree", treeData: JSON.parse(JSON.stringify(field.children || [])), group: "自定义分类"})));
        }
    }

    get dataRules() {
        return {
            "name": [
                {required: true, message: "请输入筛选器名称", trigger: "blur"}
            ]
        }
    }

    showSaveAdvFilter() {
        this.showSaveFilterWin = true;
    }

    saveAdvFilter() {
        const form = this.$refs.saveForm as any;
        form.validate((isValid: boolean) => {
            if (!isValid) {
                return;
            }
            const postedData = Object.assign({}, this.filterData);
            postedData.filterCondition = (this.$refs.adv as any).getSearchData();
            this.$http.post({url: API_BIS_FILTER, path: {projectId: this.projectId}}, postedData).then(() => {
                this.savedFilter = true;
                showSuccess("保存成功");
                this.closeSaveDialog();
            });
        });
    }

    searchData() {
        const queryStr = (this.$refs.adv as any).getSearchData();
        if (!isEmptyOrWhiteSpace(queryStr)) {
            this.$emit("query", queryStr);
        }
        this.closeDialog();
    }

    closeDialog() {
        this.$emit("update:visible", false);
        if (this.savedFilter) {
            this.$emit("data-changed");
        }
    }

    closeSaveDialog() {
        this.showSaveFilterWin = false;
        this.filterData = {name: "", markPublic: false};
    }
}
